export default "__VITE_ASSET__BNe07vJV__"